var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showBanner
    ? _c(
        "div",
        { staticClass: "cookie-banner" },
        [
          _c(
            "div",
            { staticClass: "cookie-banner-content" },
            [
              _c("fa", { attrs: { icon: "cookie-bite", size: "lg" } }),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "This site uses operational cookies that are essential for the site to function. By continuing to use this site you agree to our use of cookies."
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "got-it-button",
              attrs: { type: "is-primary" },
              on: { click: _vm.dismiss },
            },
            [_vm._v("Got it")]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }